import Axios from 'axios';
import Qs from 'qs';

export default {

  // 公式管理分页列表
  listPage(
    keyword,
    expenses_type_id,
    page,
    per_page
  ) {
    return Axios.get('/shjf/api/admin/formula', {
      params: {
        keyword,
        expenses_type_id,
        page,
        per_page
      },
      paramsSerializer(params) {
        return Qs.stringify(params);
      }
    });
  },

  // 公式管理列表
  list(
    expenses_type_id
  ) {
    return Axios.get('/shjf/api/admin/formula/list', {
      params: {
        expenses_type_id
      }
    });
  },

  // 添加公式管理
  add(
    name,
    expenses_type_id,
    content,
    remark
  ) {
    return Axios.post('/shjf/api/admin/formula', {
      name,
      expenses_type_id,
      content,
      remark
    });
  },

  // 编辑公式管理
  edit(
    id,
    name,
    expenses_type_id,
    content,
    remark
  ) {
    return Axios.put(`/shjf/api/admin/formula/${id}`, {
      name,
      expenses_type_id,
      content,
      remark
    });
  },

  // 公式管理删除
  del(
    id
  ) {
    return Axios.delete(`/shjf/api/admin/formula/${id}`);
  },

  // 公式管理详情
  info(
    id
  ) {
    return Axios.get(`/shjf/api/admin/formula/${id}`);
  }

}